import { render, staticRenderFns } from "./OxygenBorderRadiusInput.vue?vue&type=template&id=58c4d6ca&scoped=true&"
import script from "./OxygenBorderRadiusInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenBorderRadiusInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4d6ca",
  null
  
)

export default component.exports